<template>
  <div class="goods-container">
    <!--  v-if="$route.name === 'goodsManagement'" -->
    <div class="page" v-if="$route.name !== 'goodsDetail'">
      <div class="filter">
        <el-form :model="formQuery" inline size="small">
          <div class="form-left">
            <el-form-item label="商品名称">
              <el-input v-model="formQuery.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品类型">
              <el-select v-model="formQuery.category" placeholder="请选择" filterable>
                <el-option :label="item.label" :value="item.value" v-for="item of categoryList" :key="item.value"></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="商品状态">
              <el-select
                v-model="formQuery.state"
                placeholder="请选择"
                filterable
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item of stateList"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="商品编号">
              <el-input v-model="formQuery.productNumber" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="methodSearch">查询</el-button>
            </el-form-item>
            <br />
            <el-form-item label="创建时间">
              <el-date-picker v-model="formQuery.time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" placement="bottom-start" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="content">
        <div class="operation">
          <el-button type="primary" size="medium" icon="el-icon-document-add" @click="methodHandle(null, 'add')">添加商品</el-button>
        </div>
        <el-table size="small" :data="tableData" :header-cell-style="{
            background: '#f5f7fa',
            color: '#909399',
            'font-size': '14px',
          }" :header-row-style="{
            'border-radius': '5px',
            overflow: 'hidden',
          }" stripe>
          <el-table-column v-for="item in tableTitle" :key="item.value" :label="item.label" :prop="item.value" :align="item.align || 'center'" :width="item.width">
            <template slot-scope="scope">
              <div class="pic-name" v-if="item.value === 'name'">
                <img :src="scope.row.highPictureUrl" alt="" />
                <span>{{ scope.row[item.value] }}</span>
              </div>
              <div v-else-if="item.value === 'category'">
                {{ categoryMap[scope.row[item.value]] }}
              </div>
              <div v-else-if="item.value === 'state'">
                {{ stateMap[scope.row[item.value]] }}
              </div>
              <div v-else-if="item.value === 'operation'">
                <el-button type="text" size="mini" @click="methodHandle(scope.row, 'edit')">
                  编辑
                </el-button>
                <el-button type="text" size="mini" v-if="scope.row.state === 1" @click="methodHandle(scope.row, 'on')">
                  上架
                </el-button>
                <el-button type="text" size="mini" v-if="scope.row.state !== 1" style="color:#e4393c" @click="methodHandle(scope.row, 'off')">
                  下架
                </el-button>
                <!-- v-if="scope.row.category === 2" -->
                <el-button type="text" size="mini" @click="methodHandle(scope.row, 'delete')">
                  删除
                </el-button>
              </div>
              <div v-else>{{ scope.row[item.value] }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.currentPage" background :page-sizes="[10, 20, 30, 40]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- <router-view  v-bind="$attrs" v-else></router-view> -->
    <router-view v-else />
  </div>
</template>
<script>
import {
  api_schoolProductQueryList,
  api_schoolProductEdit,
  api_schProductCheckExchange, // 商品管理-实物商品删除校验
} from '@/api/javaApi'

export default {
  name: 'goodsManagement',
  props: ['campusData'], // 使用$attrs接收校区数据，可以多级传参，不能用props接收，否则下级中断
  data: () => ({
    formQuery: {
      name: '',
      productNumber: '',
      eduCampusId: null,
      time: null,
      category: null,
      state: null,
    },
    categoryList: [
      { label: '全部', index: null },
      { label: '伴学精灵', value: 0 },
      { label: '头像挂件', value: 1 },
      { label: '实物', value: 2 },
      { label: '头像', value: 3 },
    ],
    categoryMap: {
      null: '全部',
      0: '伴学精灵',
      1: '头像挂件',
      2: '实物',
      3: '头像',
    },
    stateList: [
      { label: '全部', index: null },
      { label: '兑换中', value: 0 },
      { label: '下架', value: 1 },
      { label: '库存不足', value: 2 },
      // { label: '删除', value: 3 },
    ],
    stateMap: {
      null: '全部',
      0: '兑换中',
      1: '下架',
      2: '库存不足',
      3: '删除',
    },
    page: {
      pageSize: 10,
      currentPage: 1,
      total: 1,
    },
    tableTitle: [
      { label: '商品排序', value: 'sort' },
      { label: '商品信息', value: 'name', width: 200 },
      { label: '商品编号', value: 'productNumber' },
      { label: '商品类型', value: 'category' },
      { label: '商品价格', value: 'cost' },
      { label: '库存', value: 'inventory' },
      { label: '已兑换数量', value: 'exchangeNum' },
      { label: '消耗星币', value: 'starNum' },
      { label: '创建时间', value: 'createTime' },
      // { label: '商品状态', value: 'state' },
      { label: '操作人', value: 'updater' },
      { label: '操作', value: 'operation', width: '120', align: 'center' },
    ],
    tableData: [],
  }),
  watch: {
    $route(to) {
      if (to.query.refresh) {
        this.methodSearch()
        const currentRoute = to
        this.$router.replace({ ...currentRoute, query: {} })
      }
    },
  },
  created() {
    // this.formQuery.eduCampusId = this.$attrs.campusData[0]
    this.formQuery.eduCampusId = this.campusData[0]
    this.methodSearch()
  },
  methods: {
    // 查看详情
    async methodHandle(row, key) {
      switch (key) {
        case 'add': // 添加
          this.$router.push({ name: 'goodsDetail' })
          break
        case 'delete': // 删除
          {
            let deleteText = '确认要删除商品吗?'
            if (row.category === 2) {
              const beExchanged = await api_schProductCheckExchange({ id: row.id })
              console.log(beExchanged)
              deleteText = !beExchanged ? '该商品有兑换订单，您是否删除?' : deleteText;
            }
            this.$confirm(deleteText, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              api_schoolProductEdit({
                id: row.id,
                state: 3,
                updater: this.$store.state.user.userInfo.id,
                eduCampusId: this.formQuery.eduCampusId,
              }).then((res) => {
                console.log(res)
                this.$message({
                  type: 'success',
                  message: `删除成功!`,
                })
                this.methodSearch()
              })
            })
          }
          break
        case 'edit': // 编辑
          this.$router.push({ name: 'goodsDetail', query: row })
          break
        case 'on': // 上架
          api_schoolProductEdit({
            id: row.id,
            state: 0,
            updater: this.$store.state.user.userInfo.id,
            eduCampusId: this.formQuery.eduCampusId,
          }).then((res) => {
            console.log(res)
            this.$message({
              type: 'success',
              message: `上架成功!`,
            })
            this.methodSearch()
          })
          break
        case 'off': // 下架
          this.$confirm(`确认要下架商品吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            api_schoolProductEdit({
              id: row.id,
              state: 1,
              updater: this.$store.state.user.userInfo.id,
              eduCampusId: this.formQuery.eduCampusId,
            }).then((res) => {
              console.log(res)
              this.$message({
                type: 'success',
                message: `下架成功!`,
              })
              this.methodSearch()
            })
          })
          break
        default:
          return false
      }
    },
    // 切换页数
    handleSizeChange(size) {
      this.page.pageSize = size
      this.page.currentPage = 1
      this.methodSearch()
    },
    // 切换页码
    handleCurrentChange(page) {
      this.page.currentPage = page
      this.methodSearch()
    },
    // 查询
    methodSearch() {
      this.schoolProductQueryList()
    },
    // 重置查询参数
    resetQuery() {
      this.formQuery = {
        ...this.formQuery,
        ...{
          name: '',
          productNumber: '',
          time: null,
          category: null,
          state: null,
        },
      }
      this.tableData = []
    },
    schoolProductQueryList() {
      let startTime = null,
        endTime = null
      if (this.formQuery.time) {
        startTime =
          this.formQuery.time.length > 0 ? this.formQuery.time[0] : null
        endTime = this.formQuery.time.length > 0 ? this.formQuery.time[1] : null
      }
      api_schoolProductQueryList({
        pageRequest: {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
        },
        name: this.formQuery.name || null,
        category: this.formQuery.category,
        productNumber: this.formQuery.productNumber,
        startTime,
        endTime,
        eduCampusId: this.formQuery.eduCampusId,
        state: this.formQuery.state,
      }).then((res) => {
        if (res.content) this.tableData = res.content
        this.tableData.forEach((item) => {
          item.highPictureUrl =
            this.$store.state.resource.picBaseUrl + item.highPictureUrl
        })
        this.page = {
          currentPage: res.pageNum,
          pageSize: res.pageSize,
          total: res.totalSize,
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
.goods-container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
  margin-bottom: 10px;
  .page {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    // padding: 20px 30px;
    // background: #ffffff;
    // box-shadow: 0px 0px 4px 0px #f0f4f5;
    // border-radius: 5px;
    // border: 1px solid #f4f5f9;
    .filter {
      .el-form {
        display: flex;
        justify-content: space-between;
      }
    }
    .content {
      .el-table {
        .pic-name {
          display: flex;
          align-items: center;
          img {
            width: 50px;
            margin-right: 10px;
          }
        }
      }
      .operation {
        padding: 10px 0;
      }
      .pagination {
        display: flex;
        justify-content: flex-end;
        padding: 10px 0;
      }
    }
  }
}
</style>
